(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row/assets/javascripts/extensions/ball-row-wininfo.js') >= 0) return;  svs.modules.push('/components/tur/ball-row/assets/javascripts/extensions/ball-row-wininfo.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
svs.tur.ball.row.extensions = svs.tur.ball.row.extensions || {};
class WinInfo extends svs.tur.Base {
  constructor(row) {
    super({
      className: 'ball-row-wininfo'
    });
    this.row = row;
    this.row.$inner.appendChild(this.$el);
    this.reset();
  }
  render() {
    return this.$el;
  }
  set() {
    let winStr = this.correctNumbers;
    if (this.correctExtraNumbers) {
      winStr += " + ".concat(this.correctExtraNumbers);
    }
    if (!this.row.questionMarkWinInfo) {
      winStr = '?';
    }
    winStr += " r\xE4tt";
    this.$el.innerText = winStr;
  }
  reset() {
    this.$el.innerText = '';
    this.correctTotalNumbers = 0;
    this.prevCorrectTotalNumbers = 0;
    this.correctNumbers = 0;
    this.correctExtraNumbers = 0;
    this.set();
  }
  add() {
    let correctNumbers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let correctExtraNumbers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    this.row.questionMarkWinInfo = true;
    if (correctNumbers) {
      this.correctNumbers += correctNumbers;
    }
    if (correctExtraNumbers) {
      this.correctExtraNumbers += correctExtraNumbers;
    }
    this.prevCorrectTotalNumbers = this.correctTotalNumbers;
    this.correctTotalNumbers = this.correctNumbers + this.correctExtraNumbers;
    this.set();
  }
}
svs.tur.ball.row.extensions.WinInfo = WinInfo;

 })(window);